import { FC, ReactElement } from "react";
import { Typography } from "@mui/material";

const CardHeading: FC<{ text: string }> = ({ text }): ReactElement => {
  return (
    <Typography color="#030712" variant="h3" fontSize={20} fontWeight={500}>
      {text}
    </Typography>
  );
};

export default CardHeading;
